import { Link } from 'react-router-dom';
import { DocumentKindsSettings } from '../features/documents/DocumentKindsSettings';
import { usePageTitle } from '../hooks/usePageTitle';

export function SettingsDocumentKindsPage() {
  usePageTitle('Document kinds');
  return (
    <div className="mx-auto max-w-2xl space-y-4 px-4 py-6 pb-24 sm:pb-8">
      <div>
        <Link to="/settings" className="text-sm text-slate-500 hover:text-pine">← Settings</Link>
        <h1 className="mt-2 font-display text-2xl font-semibold text-ink">Document kinds</h1>
      </div>
      <DocumentKindsSettings />
    </div>
  );
}
